<app-access-item [icon]="'/assets/icons/person-card.svg'" [iconColor]="iconColor()" [hideOverflow]="true">
  <app-access-item-header>
    <span>Identification</span>
    <app-upgrade-badge location="public-password-item" scope="gallery:force-identification"></app-upgrade-badge>
  </app-access-item-header>
  <app-access-item-cta>
    <label for="require-identification" class="save-toggle">
      <app-switch
        [noInteraction]="!('gallery:force-identification' | billingScope) || !galleryPermissions().can_edit"
        [smallish]="true"
      >
        <input
          type="checkbox"
          id="require-identification"
          [(ngModel)]="requireIdentification"
          (ngModelChange)="toggle()"
          [disabled]="!('gallery:force-identification' | billingScope) || !galleryPermissions().can_edit"
        />
        <label for="require-identification"></label>
      </app-switch>
    </label>
  </app-access-item-cta>
</app-access-item>
